import { render } from "./SportView.vue?vue&type=template&id=3fbce05b&scoped=true"
import script from "./SportView.vue?vue&type=script&lang=js"
export * from "./SportView.vue?vue&type=script&lang=js"

import "./SportView.vue?vue&type=style&index=0&id=3fbce05b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbce05b"]])

export default __exports__